import { useEffect } from 'react';
import { EventName } from '../../tracking/EventName';
import { getTracker } from '../../tracking/getTracker';
import { getHasAcq0141TrackingParam } from './acq0141Utils';
import { getQueryParam } from '../../routing/getQueryParam';
let hasExposureBeenTrackedForAcq0141Cache = false;
export function getHasExposureBeenTrackedForAcq0141() {
  return hasExposureBeenTrackedForAcq0141Cache;
}
export function setHasExposureBeenTrackedForAcq0141() {
  hasExposureBeenTrackedForAcq0141Cache = true;
}
export function resetExposureForAcq0141() {
  hasExposureBeenTrackedForAcq0141Cache = false;
}
export const trackAcq0141ExperimentExposure = () => {
  setHasExposureBeenTrackedForAcq0141();
  const externalExperimentParameter = getQueryParam('external-experiment-parameter');
  getTracker().track(EventName.ExperimentExposure, {
    action: externalExperimentParameter
  }, true);
};
export const useTrackAcq0141Exposure = () => {
  const exposureHasBeenTracked = getHasExposureBeenTrackedForAcq0141();
  const hasAcq0141TrackingParam = getHasAcq0141TrackingParam();
  useEffect(() => {
    if (hasAcq0141TrackingParam && !exposureHasBeenTracked) {
      trackAcq0141ExperimentExposure();
    }
  });
};